import { Card, Badge, Tabs, TabsContent, TabsList, TabsTrigger } from '@shared/ui/primitives';
import { TicketList } from '@/features/it-service/components/TicketList';
import { useAuthStore } from '@/stores/authStore';
import { User, Clock, CheckCircle, AlertTriangle } from 'lucide-react';

export function MyTicketsPage() {
    const { user } = useAuthStore();

    if (!user || user.userType !== 'tenant-user') {
        return (
            <div className="">
                <Card className="p-8 text-center">
                    <h2 className="text-xl font-semibold mb-2">로그인이 필요합니다</h2>
                    <p className="text-muted-foreground">내 티켓을 보려면 먼저 로그인해주세요.</p>
                </Card>
            </div>
        );
    }

    const userId = user.userId;
    const tenantId = user.tenantId;

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold text-foreground">내 티켓</h1>
                    <p className="text-muted-foreground mt-1">
                        내가 생성하거나 담당하고 있는 티켓들을 확인할 수 있습니다.
                    </p>
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <User className="w-4 h-4" />
                    <span>{user.displayName || userId}</span>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <Card className="p-4">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-blue-100 rounded-lg">
                            <User className="w-5 h-5 text-blue-600" />
                        </div>
                        <div>
                            <p className="text-sm text-muted-foreground">내가 생성한 티켓</p>
                            <p className="text-2xl font-bold text-foreground">-</p>
                        </div>
                    </div>
                </Card>

                <Card className="p-4">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-orange-100 rounded-lg">
                            <Clock className="w-5 h-5 text-orange-600" />
                        </div>
                        <div>
                            <p className="text-sm text-muted-foreground">담당 중인 티켓</p>
                            <p className="text-2xl font-bold text-foreground">-</p>
                        </div>
                    </div>
                </Card>

                <Card className="p-4">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-yellow-100 rounded-lg">
                            <AlertTriangle className="w-5 h-5 text-yellow-600" />
                        </div>
                        <div>
                            <p className="text-sm text-muted-foreground">진행 중인 티켓</p>
                            <p className="text-2xl font-bold text-foreground">-</p>
                        </div>
                    </div>
                </Card>

                <Card className="p-4">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-green-100 rounded-lg">
                            <CheckCircle className="w-5 h-5 text-green-600" />
                        </div>
                        <div>
                            <p className="text-sm text-muted-foreground">완료된 티켓</p>
                            <p className="text-2xl font-bold text-foreground">-</p>
                        </div>
                    </div>
                </Card>
            </div>

            <Tabs defaultValue="reported" className="space-y-6">
                <TabsList className="grid w-full grid-cols-2">
                    <TabsTrigger value="reported" className="flex items-center gap-2">
                        <User className="w-4 h-4" />
                        내가 생성한 티켓
                    </TabsTrigger>
                    <TabsTrigger value="assigned" className="flex items-center gap-2">
                        <Clock className="w-4 h-4" />
                        내가 담당하는 티켓
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="reported" className="space-y-4">
                    <Card className="p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-semibold">내가 생성한 티켓</h3>
                            <Badge variant="outline">Reporter: {userId}</Badge>
                        </div>
                        <TicketList tenantId={tenantId} defaultFilters={{ reporter: userId }} />
                    </Card>
                </TabsContent>

                <TabsContent value="assigned" className="space-y-4">
                    <Card className="p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-semibold">내가 담당하는 티켓</h3>
                            <Badge variant="outline">Assignee: {userId}</Badge>
                        </div>
                        <TicketList tenantId={tenantId} defaultFilters={{ assignee: userId }} />
                    </Card>
                </TabsContent>
            </Tabs>
        </div>
    );
}
